/**
 * Maps Einstein entity types to their Galileo root route paths.
 *
 * This is the single source of truth for "given an entity in Einstein,
 * what is its page URL in Galileo?" Every navigation site (entity badges,
 * queue rows, task "Go" buttons) resolves through this function so the
 * mapping stays centralized and a new entity type is a one-line addition.
 */

const ENTITY_TYPE_TO_ROUTE: Readonly<Record<string, string>> = {
    load: "/loads",
    order: "/orders",
    customer: "/customers",
    carrier: "/carriers",
    facility: "/facilities",
};

/**
 * Build the Galileo detail path for a given entity. Returns null for
 * entity types that don't map to a Galileo page (e.g., synthetic types
 * like "user" used by ad-hoc workflows).
 */
export function galileoEntityHref(entityType: string, entityId: string): string | null {
    const base = ENTITY_TYPE_TO_ROUTE[entityType.toLowerCase()];
    if (base === undefined) return null;
    return `${base}/${encodeURIComponent(entityId)}`;
}
